import { Route, Routes, useNavigate, Navigate } from "react-router-dom";
import { Toaster } from "sonner";
import LoginPage from "./pages/LoginPage";
import Setup2FAPage from "./pages/Setup2FAPage";
import Components from "./pages/components";
import ForgotPasswordPage from "./pages/ForgotPasswordPage";
import ResetPasswordPage from "./pages/ResetPassowordPage";
import SignupPage from "./pages/SignupPage";
import DashboardLayoutWrapper from "./components/AppDrawerComponent";
import MemberLayout from "./components/member/MemberLayout";
import ManagementLayout from "./components/management/ManagementLayout";
import AdminLoginPage from "./pages/AdminLoginPage";
import OpenOrderPage from "./pages/OpenOrderPage";
import MemberOpenOrderPage from "./pages/OpenOrderPage/MemberOpenOrderPage";
import AdminDashboard from "./pages/DashboardPage/AdminDashboard";
import ManagerDashboard from "./pages/DashboardPage/ManagerDashboard";
import MemberDashboard from "./pages/DashboardPage/MemberDashboard";
import Unauthorized from "./auth/Unauthorized";
import PageNotFound from "./auth/PageNotFound";
import RequireAuth from "./auth/RequireAuth";
import QuotesPage from "./pages/QuotesPage";
import MemberQuotesPage from "./pages/QuotesPage/MemberQuotesPage";
import MemberWithdrawPage from "./pages/WalletPages/MemberWithdrawPage";
import MemberQuoteFormPage from "./pages/QuotesPage/MemberQuoteFormPage";
import MemberViewQuotePage from "./pages/QuotesPage/MemberViewQuotePage";
import QuoteFormPage from "./pages/QuotesPage/QuoteFormPage";
import { VerificationPage } from "./pages/AppleRidirectionPage";
import UserManagementPage from "./pages/UserManagementPage";
import UserRegisterationForm from "./pages/UserManagementPage/UserRegisterationForm";
import ErrorPage from "./auth/ErrorPage";
import ProfilePage from "./pages/ProfilePage";
import MemberProfilePage from "./pages/ProfilePage/MemberProfilePage";
import UserViewPage from "./pages/UserManagementPage/UserViewProfile";
import PreQuotedCooksPage from "./pages/PrequotedCooksPage";
import BrandsAndSetsPage from "./pages/BrandsAndSetsPage";
import EditProfilePage from "./pages/EditUserProfile";
import MemberEditProfilePage from "./pages/EditUserProfile/MemberEditProfilePage";
import UserRegisterationEditForm from "./pages/UserManagementPage/EditUserManagementForm";
import ViewQuoteDetail from "./pages/QuotesPage/ViewQoutePage";
import MemberPreQuotedCooksPage from "./pages/PrequotedCooksPage/PreQuotedPageForMember/PQCMemberPage";
import SellPage from "./pages/SellPage";
import InstoreFlipsPage from "./pages/InstoreFlipsPages";
import InstoreFlipsFormPage from "./pages/InstoreFlipsPages/InstoreFlipsForm";
import LiveOrderPage from "./pages/LiveOrderPage";
import MemberInstoreFlipsCooksPage from "./pages/InstoreFlipsPages/InstoreFlipsPageForMember/InstoreFlipsMemberPage";
import PendingRSCQuotesPage from "./pages/PendingRSCQuotesPage";
import ViewInstoreFlipsFormPage from "./pages/InstoreFlipsPages/EditInstoreFlips";
import ViewLiveOrderPage from "./pages/LiveOrderPage/ViewLiveOrder";
import ShippingAndTrackingPage from "./pages/ShippingAndTrackingPage";
import MemberShippingAndTrackingPage from "./pages/ShippingAndTrackingPage/MemberShippingAndTrackingPage";
import ViewShipmentDetail from "./pages/ShippingAndTrackingPage/ViewShipmentPage";
import UploadShipmentReceiptPage from "./pages/ShippingAndTrackingPage/UploadRecieptPage";
// import PayoutPage from "./pages/PayoutsPage";
import CreateShipmentPage from "./pages/ShippingAndTrackingPage/CreateShipmentPage";
import MemberPayoutPage from "./pages/PayoutsPage/PayoutMemberPage";
import UploadShipmentLabelPage from "./pages/ShippingAndTrackingPage/UploadShipmentLabelPage";
import ViewPayoutPage from "./pages/PayoutsPage/PayoutView";
import AnalyticsPage from "./pages/AnalyticsPage";
import ManagementPayoutPage from "./pages/PayoutsPage";
import UpdatePayoutFormPage from "./pages/PayoutsPage/EditPayoutPage";
import FAQPages from "./pages/helpAndSupportPage";
import TicketFormPage from "./pages/helpAndSupportPage/CreateTicketPage";
import MemberHelpAndSupportPage from "./pages/helpAndSupportPage/MemberHelpAndSupportPage";
import MemberCreateTicketPage from "./pages/helpAndSupportPage/CreateTicketPage/MemberCreateTicketPage";
import TncPage from "./pages/T&CPage";
import MemberTncPage from "./pages/T&CPage/MemberTncPage";
import MemberPrivacyPolicyPage from "./pages/T&CPage/MemberPrivacyPolicyPage";
import ViewUserPaymentPage from "./pages/PayoutsPage/ViewPaymentDetails";
import LandingPage from "./pages/LandingPage";
import { useEffect, useState } from "react";
import LinkDiscordPage from "./pages/LinkDiscordPage";
import TermsAndCondition from "./pages/tandc";
import PrivacyPolicyPage from "./pages/privacyPolicy";
import PaymentCasesPages from "./pages/PaymentResolutionPage";
import PayoutCasesPages from "./pages/PaymentResolutionPage/PayoutCasesPage";
import ShipDirectFormPage from "./pages/ShipDirectPages/ShipDirectForm";
import EditShipDirectFormPage from "./pages/ShipDirectPages/EditShipDirectFlips";
import ShipDirectPage from "./pages/ShipDirectPages";
import MemberShipDirectPage from "./pages/ShipDirectPages/ShipDirectPagesForMember/ShipDirectMemberPage";
import GiftCards from "./pages/GiftCardsPage/GiftCards";
import MyGiftCards from "./pages/GiftCardsPage/MyGiftCards";
import GiftCard from "./pages/GiftCardsPage/GiftCard";
import MemberGiftCards from "./pages/GiftCardsPage/MemberGiftCards";
import MemberMyGiftCards from "./pages/GiftCardsPage/MemberMyGiftCards";
import MemberGiftCard from "./pages/GiftCardsPage/MemberGiftCard";
import WalletPage from "./pages/WalletPages";
import MemberWalletPage from "./pages/WalletPages/MemberWalletPage";
import PaymentMethodPages from "./pages/PaymentMethodPage";
import MemberPaymentMethodPage from "./pages/PaymentMethodPage/MemberPaymentMethodPage";
import ManagementWithdrawRequestPage from "./pages/PayoutsPage/WithdrawRequestPage";
import WithdrawPage from "./pages/WalletPages/WithdrawPage";
import ViewWithdrawRequestPage from "./pages/PayoutsPage/ViewWithdrawRequest";
import GiftCardRedemptionPage from "./pages/PayoutsPage/GiftCardRedemptionPage";
import VendorWithdrawRequestPage from "./pages/PayoutsPage/VendorWithdrawRequestPage";
import GiftCardManagerPage from "./pages/GiftCardsPage";
import AddGiftCardFormPage from "./pages/GiftCardsPage/AddGiftCardPage";
import { getUsers } from "./utils/getUser";
import EditGiftCardFormPage from "./pages/GiftCardsPage/EditGiftCardPage";
import WarehouseInbound from "./pages/Warehouse/Inbound";
import WarehouseTrackInboundItem from "./pages/Warehouse/TrackInboundItem";
import WarehouseInventory from "./pages/Warehouse/Inventory";
import ViewInventoryDetail from "./pages/Warehouse/Inventory/ViewInventory";
import WarehouseInboundItem from "./pages/Warehouse/Inbound/InboundItem";
import MyCardPage from "./pages/MyCardPage";
import ConditionDamagesPage from "./pages/ConditionDamagesPage";

const logoutChannel = new BroadcastChannel("logout_channel");

const ROLES = {
  Admin: "superadmin",
  Manager: "manager",
  User: "member",
  Vendor: "vendor",
  WarehouseAdmin: "WAREHOUSE_ADMIN",
  WarehouseStaff: "WAREHOUSE_STAFF",
};

function App() {
  const navigate = useNavigate();
  const [userRole, setUserRole] = useState(null);

  useEffect(() => {
    setUserRole(getUsers()?.role);
  }, [navigate]);

  useEffect(() => {
    const handleLogout = (event) => {
      if (event.data === "logout") {
        sessionStorage.clear();
        localStorage.clear();
        navigate("/");
      }
    };

    logoutChannel.onmessage = handleLogout;

    return () => {
      logoutChannel.onmessage = null;
    };
  }, [navigate]);

  return (
    <div className="App">
      <Toaster
        theme="dark"
        position="top-right"
        toastOptions={{
          unstyled: true,
          classNames: {
            toast: "member-sonner-toast",
            content: "member-sonner-content",
            title: "member-sonner-title",
            description: "member-sonner-description",
            icon: "member-sonner-icon",
            closeButton: "member-sonner-close",
            success: "member-sonner-toast--success",
            error: "member-sonner-toast--error",
            warning: "member-sonner-toast--warning",
            info: "member-sonner-toast--info",
          },
        }}
        closeButton
      />
      <AuthorizationRoutes />
      <AuthenticatedRoutes userRole={userRole} />
    </div>
  );
}

function AuthorizationRoutes() {
  return (
    <Routes>
      <Route path="/login" element={<LoginPage />} />
      <Route path="/setup-2fa" element={<Setup2FAPage />} />
      <Route path="/forgot-password" element={<ForgotPasswordPage />} />
      <Route path="/reset-password" element={<ResetPasswordPage />} />
      <Route path="/signup" element={<SignupPage />} />
      <Route path="/verify-invite" element={<AdminLoginPage />} />
      {/* <Route path="/warehouse-login" element={<WarehouseLoginPage />} /> */}

      <Route path="/unauthorized" element={<Unauthorized />} />
      <Route path="/page-not-found" element={<PageNotFound />} />
      <Route path="/apple-verification" element={<VerificationPage />} />
      <Route path="/error" element={<ErrorPage />} />
      <Route path="/terms-and-condition" element={<TermsAndCondition />} />
      <Route path="/privacy-policy" element={<PrivacyPolicyPage />} />
      <Route path="/" element={<LandingPage />} />
    </Routes>
  );
}

function ConditionalLayout() {
  const user = getUsers();
  if (user?.role === "MEMBER") {
    return <MemberLayout />;
  }
  return <ManagementLayout />;
}

function AuthenticatedRoutes({ userRole }) {
  return (
    <Routes>
      <Route element={<ManagementLayout />}>
        <Route path="/testing" element={<Components />} />
        <Route path="/link-discord" element={<LinkDiscordPage />} />
        <Route element={<RequireAuth allowedRoles={[ROLES.Admin]} />}>
          <Route path="/admin-dashboard" element={<AdminDashboard />} />
          <Route path="admin/change-password" element={<ResetPasswordPage />} />
          <Route path="user-management" element={<UserManagementPage />} />
          <Route
            path="user-management/view-profile"
            element={<UserViewPage />}
          />
          <Route
            path="user-management/edit-profile"
            element={<UserRegisterationEditForm />}
          />
        </Route>

        {(userRole === "SUPERADMIN" ||
          userRole === "WAREHOUSE_ADMIN" ||
          userRole === "WAREHOUSE_STAFF") && (
          <>
            <Route path="warehouse/inbound" element={<WarehouseInbound />} />
            <Route
              path="warehouse/inbound/inbound-item"
              element={<Navigate to="/warehouse/inbound" replace />}
            />
            <Route
              path="warehouse"
              element={<Navigate to="/warehouse/inbound" replace />}
            />
            <Route
              path="warehouse/inbound/inbound-item/:id"
              element={<WarehouseInboundItem />}
            />
            <Route
              path="warehouse/inbound/track-inbound-item"
              element={<WarehouseTrackInboundItem />}
            />
            <Route
              path="warehouse/inventory"
              element={<WarehouseInventory />}
            />
            <Route
              path="warehouse/inventory/view-inventory"
              element={<Navigate to="/warehouse/inventory" replace />}
            />
            <Route
              path="warehouse/inventory/view-inventory/:upcValue"
              element={<ViewInventoryDetail />}
            />
          </>
        )}
        {(userRole === "SUPERADMIN" || userRole === "MANAGER") && (
          <Route
            element={
              <RequireAuth allowedRoles={[ROLES.Admin, ROLES.Manager]} />
            }
          >
            <Route path="/manager-dashboard" element={<ManagerDashboard />} />

            {/* ROUTES FOR PREQUOTED COOKS */}
            <Route path="/dashboard">
              <Route
                path="pending-rsc-quotes"
                element={<PendingRSCQuotesPage />}
              />
              <Route path="sell-catalog" element={<PreQuotedCooksPage />} />
              <Route path="brands-and-sets" element={<BrandsAndSetsPage />} />
              <Route
                path="prequoted-cooks"
                element={<Navigate to="/dashboard/sell-catalog" replace />}
              />
              <Route
                path="prequoted-cooks/create-form"
                element={<Navigate to="/dashboard/sell-catalog" replace />}
              />
              <Route
                path="prequoted-cooks/edit-information"
                element={<Navigate to="/dashboard/sell-catalog" replace />}
              />
              <Route
                path="sell-catalog/create-form"
                element={<Navigate to="/dashboard/sell-catalog" replace />}
              />
              <Route
                path="sell-catalog/edit-information"
                element={<Navigate to="/dashboard/sell-catalog" replace />}
              />
{/* ROUTES FOR INSTOREFLIPS COOKS */}
              <Route path="instore-flips" element={<InstoreFlipsPage />} />
              <Route
                path="instore-flips/create-form"
                element={<InstoreFlipsFormPage />}
              />
              <Route
                path="instore-flips/edit-information"
                element={<ViewInstoreFlipsFormPage />}
              />

              {/* ROUTES FOR SHIPDIRECT COOKS */}
              <Route path="ship-direct" element={<ShipDirectPage />} />
              <Route
                path="ship-direct/create-form"
                element={<ShipDirectFormPage />}
              />
              <Route
                path="ship-direct/edit-information"
                element={<EditShipDirectFormPage />}
              />

              {/* ROUTES FOR GIFT CARDS*/}
              <Route path="gift-cards" element={<GiftCardManagerPage />} />
              <Route path="gift-cards/add" element={<AddGiftCardFormPage />} />
              <Route
                path="gift-cards/edit"
                element={<EditGiftCardFormPage />}
              />

              {/* ORDERS */}
              <Route path="orders" element={<LiveOrderPage />} />
              <Route
                path="live-orders"
                element={<Navigate to="/dashboard/orders" replace />}
              />
              <Route
                path="live-orders/view-details"
                element={<ViewLiveOrderPage />}
              />

              {/* PAYOUTS ROUTES */}
              <Route path="payouts" element={<ManagementPayoutPage />} />
              <Route
                path="payouts/update-details"
                element={<UpdatePayoutFormPage />}
              />
              <Route
                path="payouts/view-information"
                element={<ViewPayoutPage />}
              />
              <Route
                path="payouts/view-payment-details"
                element={<ViewUserPaymentPage />}
              />
              <Route
                path="payouts/withdraw-request"
                element={<ManagementWithdrawRequestPage />}
              />
              <Route
                path="payouts/withdraw-request/view"
                element={<ViewWithdrawRequestPage />}
              />
              <Route
                path="payouts/withdraw-request/initiate-payment"
                element={<UpdatePayoutFormPage />}
              />
              <Route
                path="payouts/withdraw-request/redemption"
                element={<GiftCardRedemptionPage />}
              />
              <Route
                path="payouts/payout-resolution"
                element={<PaymentCasesPages />}
              />
              <Route
                path="payouts/payout-cases"
                element={<PayoutCasesPages />}
              />

              <Route path="add-user" element={<UserRegisterationForm />} />
              <Route
                path="shipment/upload-shipment-label"
                element={<UploadShipmentLabelPage />}
              />

              {/* ANALYTICS ROUTES */}
              <Route path="analytics" element={<AnalyticsPage />} />
            </Route>
          </Route>
        )}

        {userRole === "VENDOR" && (
          <Route element={<RequireAuth allowedRoles={[ROLES.Vendor]} />}>
            <Route path="/dashboard">
              <Route path="gift-cards" element={<GiftCardManagerPage />} />
              <Route path="gift-cards/add" element={<AddGiftCardFormPage />} />
              <Route
                path="gift-cards/edit"
                element={<EditGiftCardFormPage />}
              />
              <Route
                path="withdraw-request"
                element={<VendorWithdrawRequestPage />}
              />
              <Route
                path="payouts/withdraw-request/view"
                element={<ViewWithdrawRequestPage />}
              />
              <Route
                path="payouts/withdraw-request/redemption"
                element={<GiftCardRedemptionPage />}
              />
            </Route>
          </Route>
        )}
      </Route>

      {(userRole === "SUPERADMIN" ||
        userRole === "MANAGER" ||
        userRole === "MEMBER") && (
        <Route element={<ConditionalLayout />}>
          <Route
            element={
              <RequireAuth
                allowedRoles={[ROLES.User, ROLES.Admin, ROLES.Manager]}
              />
            }
          >
            <Route path="/user-dashboard" element={<MemberDashboard />} />
            <Route path="/dashboard">
              <Route path="my-card" element={<MyCardPage />} />
              <Route path="condition-damages" element={<ConditionDamagesPage />} />
              <Route
                path="open-orders"
                element={userRole === "MEMBER" ? <MemberOpenOrderPage /> : <OpenOrderPage />}
              />

              {/* Completed Orders stays as a member alias, and redirects management
                  users into the unified Orders page on the Approved tab. */}
              <Route
                path="completed-orders"
                element={userRole === "MEMBER" ? <MemberOpenOrderPage /> : <Navigate to="/dashboard/orders?status=approved" replace />}
              />

              {/* QUOTES */}
              <Route
                path="quotes"
                element={userRole === "MEMBER" ? <MemberQuotesPage /> : <QuotesPage />}
              />
              <Route
                path="quotes/quotes-form"
                element={userRole === "MEMBER" ? <MemberQuoteFormPage /> : <QuoteFormPage />}
              />
              <Route
                path="quotes/view-quotes"
                element={userRole === "MEMBER" ? <MemberViewQuotePage /> : <ViewQuoteDetail />}
              />
              {/* PREQUOTEDCOOKS */}
              <Route path="sell" element={<SellPage />} />
              <Route
                path="member-prequoted-cooks"
                element={<MemberPreQuotedCooksPage />}
              />
              {/* INSTOREFLIPS */}
              <Route
                path="member-instore-flips"
                element={<MemberInstoreFlipsCooksPage />}
              />

              {/* Ship Direct */}
              <Route
                path="member-ship-direct"
                element={<MemberShipDirectPage />}
              />
              <Route
                path="shipment"
                element={userRole === "MEMBER" ? <MemberShippingAndTrackingPage /> : <ShippingAndTrackingPage />}
              />
              <Route
                path="shipment/view-shipment"
                element={<ViewShipmentDetail />}
              />
              <Route
                path="shipment/upload-shipment-receipt"
                element={<UploadShipmentReceiptPage />}
              />
              <Route
                path="shipment/create-shipment"
                element={<CreateShipmentPage />}
              />

              {/* MEMBER PAYOUT ROUTES */}
              <Route
                path="shipment/member-payouts"
                element={<MemberPayoutPage />}
              />
              <Route
                path="shipment/member-payouts/view-information"
                element={<ViewPayoutPage />}
              />

              {/* WALLETS */}
              <Route
                path="wallet"
                element={userRole === "MEMBER" ? <MemberWalletPage /> : <WalletPage />}
              />
              <Route
                path="wallet/gift-cards"
                element={userRole === "MEMBER" ? <MemberGiftCards /> : <GiftCards />}
              />
              <Route
                path="wallet/gift-cards/my-gift-cards"
                element={userRole === "MEMBER" ? <MemberMyGiftCards /> : <MyGiftCards />}
              />
              <Route
                path="wallet/gift-cards/my-gift-card"
                element={userRole === "MEMBER" ? <MemberGiftCard /> : <GiftCard />}
              />
              <Route
                path="wallet/:method"
                element={userRole === "MEMBER" ? <MemberWithdrawPage /> : <WithdrawPage />}
              />
              <Route
                path="wallet/payment-methods"
                element={userRole === "MEMBER" ? <MemberPaymentMethodPage /> : <PaymentMethodPages />}
              />

              {/* FAQ SECTION */}
              <Route
                path="help-support"
                element={userRole === "MEMBER" ? <MemberHelpAndSupportPage /> : <FAQPages />}
              />
              <Route
                path="help-support/create-ticket"
                element={userRole === "MEMBER" ? <MemberCreateTicketPage /> : <TicketFormPage />}
              />

              <Route
                path="my-profile"
                element={userRole === "MEMBER" ? <MemberProfilePage /> : <ProfilePage />}
              />
              <Route
                path="my-profile/edit"
                element={userRole === "MEMBER" ? <MemberEditProfilePage /> : <EditProfilePage />}
              />
              {userRole !== "MEMBER" && (
                <>
                  <Route path="user-management" element={<UserManagementPage />} />
                  <Route
                    path="user-management/view-profile"
                    element={<UserViewPage />}
                  />
                  <Route
                    path="user-management/edit-profile"
                    element={<UserRegisterationEditForm />}
                  />
                </>
              )}
              <Route
                path="t&c"
                element={userRole === "MEMBER" ? <MemberTncPage /> : <TncPage />}
              />
              {/* New page — no old MUI equivalent existed at a dashboard route
                  (only the pre-login public /privacy-policy did), so there's
                  no per-role fork to preserve here. Static legal text, no
                  member-specific data, so it's safe to render for any role
                  that reaches it directly. */}
              <Route path="privacy-policy" element={<MemberPrivacyPolicyPage />} />
            </Route>
          </Route>
        </Route>
      )}
    </Routes>
  );
}

export default App;
